import { useQuery, useQueryClient, type QueryClient } from "@tanstack/react-query";
import * as AgenticV2API from "@/services/api/agentic-v2";
import { useWindowLive } from "@/components/ui/os-layout/WindowActiveContext";
import { missionControlKeys } from "./keys";

export interface UseMissionChannelOptions {
  missionId: string;
  enabled?: boolean;
}

/** Cached mission channel thread; gated by OS window lifecycle and parent tab visibility. */
export function useMissionChannel({
  missionId,
  enabled: enabledOption = true,
}: UseMissionChannelOptions) {
  const isWindowLive = useWindowLive();
  const queryEnabled = enabledOption && isWindowLive && Boolean(missionId);

  return useQuery({
    queryKey: missionControlKeys.missionChannel(missionId),
    enabled: queryEnabled,
    refetchOnWindowFocus: queryEnabled,
    queryFn: () => AgenticV2API.getMissionThread(missionId),
  });
}

/** QueryClient accessor for mission channel cache invalidation after send. */
export function useMissionChannelQueryClient() {
  return useQueryClient();
}

/** Invalidate the mission channel cache after posting a new message. */
export function invalidateMissionChannel(
  queryClient: QueryClient,
  missionId: string,
): void {
  void queryClient.invalidateQueries({
    queryKey: missionControlKeys.missionChannel(missionId),
  });
}
